import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useLottie } from 'lottie-react';
import checkAnimation from '../../assets/Animations/Success-300x300.json';
import { redirect } from '../../utils/redirect';
import AppStateContext from '../../AppStateProvider/context';
import { complete } from '../../utils/complete';
import addParam from '../../utils/addParam';
import { encodeString } from '../../utils/encoding';
import { getUrl } from '../../utils/getUrl';

function normalizeBase(u?: string | null) {
	if (!u) return '';
	return u.trim().replace(/\/+$/, '');
}

function sanitizeMarket(m: any) {
	if (!m) return {};
	const {
		name,
		ending,
		currency,
		nedc,
		showMinimalEquipmentPopups,
		calcDomain
	} = m;
	return {
		...(name ? { name } : {}),
		...(ending ? { ending } : {}),
		...(currency ? { currency } : {}),
		...(typeof nedc === 'boolean' ? { nedc } : {}),
		...(typeof showMinimalEquipmentPopups === 'boolean'
			? { showMinimalEquipmentPopups }
			: {}),
		...(calcDomain ? { calcDomain } : {}),
	};
}

export default function Final() {
	const { t, i18n } = useTranslation();
	const { state } = useContext(AppStateContext);
	const completeState = complete(state);
	const params = new URLSearchParams(window.location.search);

	const { View } = useLottie({
		animationData: checkAnimation,
		loop: false,
		className: 'animation',
		onComplete: () => {
			if (completeState) redirect(state.brand);
		},
	});

	if (!completeState) {
		return (
			<div className='top'>
				<div className='final'>
					<h1>{t('FinalErrorHeadline')}</h1>
					<p className='p1'>{t('FinalErrorText')}</p>
				</div>
			</div>
		);
	}

	const playerUrl = normalizeBase(state.url);
	const marketSanitized = sanitizeMarket(state.market);

	const setupToStore = {
		brand: state.brand,
		market: marketSanitized,
		kvps: state.kvps && /^\d+$/.test(state.kvps) ? state.kvps : null,
		password: encodeString(state.password),
		userPassword: encodeString(state.userPassword),
		device: state.device,

		url: playerUrl || '',


		language: i18n.language,
		label: state.goToLabel,
		chromeboxLabel: state.chromeboxLabel,
		hardware: state.hardware,
		pinpairingActivationResponse: state.pinpairingActivationResponse,

		clientId: `${playerUrl || 'unknown'}_${state.device || 'device'}`,
	};

	try {
		localStorage.setItem('setup', JSON.stringify(setupToStore));
	} catch (e) {

		console.error('[Final] Fehler beim Schreiben von setup in LS', e);
	}

	if (state.apk) {
		const rotationMap: Record<'default' | 'right' | 'down' | 'left', string> = {
			default: '0',
			right: '90',
			down: '180',
			left: '270',
		};

		const params = new URLSearchParams(window.location.search);
		const orientation = (params.get('orientation') as 'default' | 'right' | 'down' | 'left') || 'left';
		const rotationValue = rotationMap[orientation];
		const umdaschVersion = params.get('device-type') || 'UmdaschV1';

		const depotUrl = getUrl(state.market, state.kvps, state.brand, state.url) + '/module/content/bpca/depot';

		const accountContent = [
			'url=' + depotUrl,
			'user=ssp',
			'password=' + (state.password ?? ''),
			'id=' + (state.device ?? ''),
			'name=' + ((state.devices?.find(d => d.includes(`(${state.device})`)) || '').split(' ')[0] || ''),
			'language=' + (state.language || i18n.language),
			'umdasch_version=' + umdaschVersion,
			'secondscreen_rotation=' + rotationValue,
		].join('\n');

		addParam('account', accountContent, true);
	}

	return (
		<div className='top'>
			<div className='final'>
				{!state.preview && (
					<>
						<h1>{t('FinalHeadline')}</h1>
						<p className='p1'>{t('FinalText')}</p>
					</>
				)}
				<>{View}</>
			</div>
		</div>
	);
}
